// https://github.com/Hacker0x01/react-datepicker

import React, { useState, useEffect  } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
  Input,
} from 'reactstrap';
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import * as MyAPI from '../../../utils/MyAPI'
import Header from '../parts/Header'
import Footer from '../parts/Footer'
import ApiSubHeader from '../parts/ApiSubHeader'
import Alert from 'react-s-alert';
import {
  // BarChart,
  Bar,
  // Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ComposedChart,
  // Line,
} from 'recharts';

// ApiUsageSummary
const ApiUsageSummary = (props) => {

  let navigate = useNavigate();
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  });

  let [loading, setLoading] = useState(false);
  let [deepSpeechToken, setDeepSpeechToken] = useState('');
  let [deepSpeechTokens, setDeepSpeechTokens] = useState([]);
  let [chartList, setChartList] = useState([])
  let [callsTodayH , setCallsTodayH] = useState(0)
  let [callsTodayM , setCallsTodayM] = useState(0)
  let [callsMonthH , setCallsMonthH] = useState(0)
  let [callsMonthM , setCallsMonthM] = useState(0)

  // componentDidMount
  useEffect(() => {
    _firstScript()
  }, []);

  let _firstScript = async() => {

    if (!login_token) {
      // redirect
      navigate("/dashboard")
    }

    // get api token list
    await _getDeepSpeechTokens()
  }

  // get api usage
  let _getApiUsage = async (_deepSpeechToken) => {

    try {

      let _results = await MyAPI.getApiUsage({
        login_token: login_token,
        ai_api_key: _deepSpeechToken,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      if (_results.calls_month) {

        let _h = 0
        let _m = _results.calls_month
        if (_m > 60) {
          _h = Math.floor(_m / 60)
          _m = _m - _h * 60
        }

        if (_h === 0) {
          setCallsMonthM(_m)
          setCallsMonthH(0)
        } else {
          setCallsMonthM(_m)
          setCallsMonthH(_h)
        }
      } else {
        setCallsMonthM(0)
        setCallsMonthH(0)
      }

      if ( _results.calls_today ) {

        let _h = 0
        let _m = _results.calls_today
        if (_m > 60) {
          _h = Math.floor(_m / 60)
          _m = _m - _h * 60
        }

        if (_h === 0) {
          setCallsTodayM(_m)
          setCallsTodayH(0)
        } else {
          setCallsTodayM(_m)
          setCallsTodayH(_h)
        }
      } else {
        setCallsTodayM(0)
        setCallsTodayH(0)
      }

      if ( _results.chart_list ) {
        setChartList(_results.chart_list)
      }

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }
  }


  // get tokens
  let _getDeepSpeechTokens = async () => {

    try {
      // logout on server
      let _results = await MyAPI.getDeepSpeechTokens({
        login_token: login_token,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      // name to display
      let _list1 = _results.list1
      for ( let i=0; i<_list1.length; i++ ) {
        let _item = _list1[i]
        let _disp = _item.api_key.substr(0, 16)+"…"
        if ( _item.memo ) {
          if (_item.memo.length < 17) {
            _disp = _item.memo
          } else {
            _disp = _item.memo.substr(0, 16)+"…"
          }

        }
        _list1[i].disp_name = _disp
      }

      // set list
      setDeepSpeechTokens(_list1)

      // set current
      for (let i=0; i<_results.list1.length; i++) {
        let item = _results.list1[i]
        if (item.disabled === false) {
          setDeepSpeechToken(item.api_key)

          // get api usage
          await _getApiUsage(item.api_key)

          break
        }
      }

      // console.log("_results.list1: ", _results.list1)

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }
  }

  // handle change
  let _handleChangeDeepSpeechToken = (e) => {
    setDeepSpeechToken(e.target.value)
    _getApiUsage(e.target.value)
  }

  return (
    <div>

      <Header />

      <ApiSubHeader />

      {/* main */}
      <Container style={{
        marginTop: 40,
      }}>

        <Row style={{
          marginTop: 20,
          marginBottom: 40,
        }}>

          <Col md="8" xs="12" />

          <Col md="4" xs="12" style={{
            textAlign: 'left',
          }}>
            api token: <br/>
            <Input onChange={_handleChangeDeepSpeechToken} type="select" name="deepSpeechToken" value={deepSpeechToken}>
              {deepSpeechTokens && deepSpeechTokens.map((item) => (
                <option key={item.api_key} value={item.api_key}>
                  {item.disp_name}
                  </option>
              ))}
            </Input>
          </Col>
        </Row>

        <Row style={{
          marginTop: 40,
          marginBottom: 40,
          color: '#777777',
        }}>

          <Col md="6" xs="12" style={{
            textAlign: 'center',
          }}>
            {callsTodayH > 0 && (
              <span>
                <span style={{
                  fontSize: 56,
                }}>
                  {callsTodayH}
                </span>
                <span style={{
                  fontSize: 28,
                }}>
                  時間
                </span>
              </span>
            )}
            <span>
              <span style={{
                fontSize: 56,
              }}>
                {callsTodayM}
              </span>
              <span style={{
                fontSize: 28,
              }}>
                分
              </span>
            </span>

            <span style={{
              fontSize: 28,
            }}>
               / 本日
            </span>
          </Col>
          <Col md="6" xs="12" style={{
            textAlign: 'center',
          }}>

            {callsMonthH > 0 && (
              <span>
                <span style={{
                  fontSize: 56,
                }}>
                  {callsMonthH}
                </span>
                <span style={{
                  fontSize: 28,
                }}>
                  時間
                </span>
              </span>
            )}

            <span>
              <span style={{
                fontSize: 56,
              }}>
                {callsMonthM}
              </span>
              <span style={{
                fontSize: 28,
              }}>
                分
              </span>
            </span>

            <span style={{
              fontSize: 28,
            }}>
               / 今月
            </span>
          </Col>

        </Row>

        <Row style={{
          marginTop: 40,
          marginBottom: 40,
          color: '#777777',
        }}>
          <Col md="12" xs="12" style={{
            textAlign: 'right',
            fontSize: 20,
          }}>
            <span>Unit: Minutes</span>
          </Col>
        </Row>

        <Row style={{
          marginTop: 40,
          marginBottom: 40,
          color: '#777777',
        }}>
          <Col md="12" xs="12" style={{
            textAlign: 'center',
          }}>

            <ResponsiveContainer width="100%" height={300}>
              <ComposedChart
                width={500}
                height={300}
                data={chartList}
                margin={{
                  top: 5, right: 30, left: 20, bottom: 5,
                }} >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" hide={true} />
                <YAxis yAxisId="left" />
                <Tooltip />
                <Legend />

                <Bar dataKey="calls" fill="#8884d8" yAxisId="left" />

              </ComposedChart>
            </ResponsiveContainer>
          </Col>
        </Row>

      </Container>


      {/* footer */}
      <Footer />

      {/* loading */}
      <Loader fullPage={true} loading={loading} />

    </div>
  )
}

export default ApiUsageSummary
